import { SheetContainer, useViewport } from "@bookingcom/bui-react";
import React, { useCallback } from "react";
import useUserAgent from "./useUserAgent.js";
import useGlobalContext from "./useGlobalContext.js";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import styles from "./useModalDialog.module.css";
import { mcn } from "../utils/mergeClassnames.js";
function useModalDialog() {
    const { isMobile } = useUserAgent();
    const i18n = useI18n();
    const { isSmall } = useViewport();
    const { locale } = useGlobalContext();
    return useCallback((props) => {
        const { children, dataTestId, fill = false, fullHeight = false, lockCloseOnOutsideClick = false, onClose, onCloseTrigger, position, showModalInMobile = false, closeAriaLabel, onAfterOpenFn, attributes, ...rest } = props;
        const calculatedPosition = isMobile && showModalInMobile ? "center" : position || (isMobile ? "bottom" : "center");
        return (React.createElement(SheetContainer, { attributes: { "data-testid": dataTestId, lang: locale, ...attributes }, closeAriaLabel: closeAriaLabel || i18n.trans(t("close")), fill: fill, lockCloseOnOutsideClick: lockCloseOnOutsideClick, onClose: onClose, onCloseTrigger: onCloseTrigger || onClose, position: calculatedPosition, className: mcn(isMobile && fullHeight ? styles.wrapper : "", isSmall && styles.wrapperSm), onAfterOpen: onAfterOpenFn, ...rest }, children));
    }, [isMobile, i18n, isSmall, locale]);
}
export default useModalDialog;
